<template>
  <div>
    <Schedule
      :id="id"
      :fields="fields"
      :data="data"
      :code="code"
      :config="config"
      :search="search"
      :months="months"
      :tournDates="tournDates"
      :newReports="newReports"
    />
  </div>
</template>

<script>
import { Schedule } from "@ocs-software/vue-ocs";
export default {
  name: "Schedule Table",
  props: ["id", "fields", "data", "code", "search", "months", "tournDates" , "newReports", "config"],
  components: {
    Schedule
  },
  filters: {
    base: function(value) {
      return btoa(value);
    },
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (this.code === item.code) return "live";
    },
    // reportReturn: function() {
    //   let arr = [];
    //   console.log("arr")
    //   console.log(arr)
    //   this.data.forEach((value) => {
    //     if (value.reports !== '') {
    //       value.reports.reports_entry.forEach((value2) => {
    //         if (value2.report_title.includes('Scores') || value2.report_title.includes('Scoreboard')) {
    //           arr.push(value2); 
    //         }
    //       })
    //     } else {
    //       console.log('No reports')
    //     }
    //   });
    // }
  },
  mounted() {
  // this.reportReturn();
  }
};
</script>

<style scoped>

</style>
<style scoped src="@/css/schedule.css"></style>